import { ICalendarSlot } from "../../../entities/calendar";
import { useCalendarSlotSelection } from "../../../shared/lib/hooks/useCalendarSlotSelection";
import { ISelectedPeriod } from "./types";
import { canSelectLessonCreateSlot } from "./canCreateLessonInSlot";

interface IProps {
    slots: Date[];
    calendarSlotsByIndex: Map<number, ICalendarSlot>;
    onSelectPeriod: (period: ISelectedPeriod) => void;
}

export const useCalendarDaySelection = ({slots, calendarSlotsByIndex, onSelectPeriod}: IProps) => {
    return useCalendarSlotSelection<ICalendarSlot>({
        slots,
        calendarSlotsByIndex,
        canSelectSlot: canSelectLessonCreateSlot,
        onSelectPeriod,
    })
}
